export const CONFIGURATION_TOKEN = 'CONFIGURATION_TOKEN';

export interface BrowserConfiguration {
    baseDomain: string;
    apiBaseDomain: string;
    nMin: number;
    nMax: number;
    nLimit: number;
    redirectPolicyDetail?: string;
    
    redemptionQuestion: string,
    investmentAmountQuestion: string,
    maxInvestmentAmount: number,

    openiddictsettings: Openiddictsettings
}

export interface Openiddictsettings {
    authority: string;
    redirectUrl: string;
    postLogoutRedirectUri: string;
    clientId: string;

    scope: string;
    responseType: string;
    silentRenew: boolean;
    renewTimeBeforeTokenExpiresInSeconds: number;
    useRefreshToken: boolean;
    ignoreNonceAfterRefresh: boolean;
}